import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { destinoRetornoSncr } from "./modules/sncr/configSncr";
import {
  LimiteDeErro,
  instalarCapturaGlobal,
} from "./shared/components/LimiteDeErro";

// B356 (AI_154): a volta do login gov.br do SNCR cai na raiz
// ("/?session_id=…&state=sncr"); encaminha para /sncr ANTES de montar o app —
// o session_id vale 30 s.
const destinoSncr = destinoRetornoSncr(window.location.pathname, window.location.search);
if (destinoSncr) window.history.replaceState(null, "", destinoSncr);

// B369 (AI_156) — identifica o BUILD sem variável de ambiente nova: o hash do
// bundle é único por versão publicada. Serve para o detalhe do erro dizer em
// que versão a tela caiu.
const versaoDoBundle = (() => {
  const scripts = Array.from(document.querySelectorAll("script[src]"));
  for (const s of scripts) {
    const m = (s as HTMLScriptElement).src.match(/main\.([a-z0-9]+)\.js/i);
    if (m) return m[1];
  }
  return undefined;
})();

instalarCapturaGlobal(versaoDoBundle);

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <LimiteDeErro versao={versaoDoBundle}>
      <App />
    </LimiteDeErro>
  </React.StrictMode>
);
